import { render, staticRenderFns } from "./merchantManage.vue?vue&type=template&id=20bc25f9&scoped=true"
import script from "./merchantManage.vue?vue&type=script&lang=js"
export * from "./merchantManage.vue?vue&type=script&lang=js"
import style0 from "./merchantManage.vue?vue&type=style&index=0&id=20bc25f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc25f9",
  null
  
)

export default component.exports